import { useGetFunctionDisplayQuery } from '@/store/api/assistantApi';

export const useGetFunctionDisplay = (id: string) =>
  useGetFunctionDisplayQuery(
    { functionDisplayId: id },
    { skip: !id },
  );
